<template>
  <div 
    :class="baseAvatarClasses" 
    class="base-avatar" 
    v-on="$listeners"
  >
    <img
      v-if="src"
      :src="src"
      width="36"
      height="36"
      loading="lazy"
      alt="Avatar"
    >
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: "medium",
    validator: (value) => ["x-small", "small", "medium", "large", "x-large"].includes(value),
  },
  shape: {
    type: String,
    default: "circle",
    validator: (value) => ["circle", "square"].includes(value),
  },
  mode: {
    type: String,
    default: "light",
    validator: (value) => ["light", "dark"].includes(value),
  },
});

const baseAvatarClasses = computed(() => ({
  [`base-avatar--size-${props.size}`]: true,
  [`base-avatar--shape-${props.shape}`]: true,
  [`base-avatar--mode-${props.mode}`]: true,
}));
</script>

<style lang="scss" scoped>
@import "./base-avatar.scss";
</style>
